import React from "react";
import { I18n } from "@aws-amplify/core";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core";
import update from "immutability-helper";
import { get, isEmpty, map, includes, filter } from "lodash";

import Box from "@material-ui/core/Box";

import CustomButton from "../../Common/CustomButton";
import FormSection from "../../Common/FormSection";

import { getLov } from "../../../utils/lov";

const styles = {
  gridLine: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, 200px)",
    gridAutoRows: "56px",
    gridGap: "24px",
  },
};

const OnsiteCountsForm = (props) => {
  const { classes, user, search, language } = props;
  const [filters, setFilters] = React.useState({});
  const [profileTypes, setProfileTypes] = React.useState();

  React.useEffect(() => {
    fetchLov();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Set initial filters
  React.useEffect(() => {
    if (!isEmpty(profileTypes)) {
      setFilters(
        update(filters, {
          profileTypes: { $set: map(profileTypes, (t) => t.id) },
          company: { $set: get(user, ["companies", 0, "id"]) },
          sites: {
            $set: map(get(user, ["companies", 0, "sites"]), (s) => s.id),
          },
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profileTypes]);

  const fetchLov = async () => {
    try {
      const profileTypes = await getLov("profileTypes");
      setProfileTypes(
        filter(profileTypes, (t) => t.active && includes([1, 2, 3, 4], t.id))
      );
    } catch (e) {
      console.log(e);
    }
  };

  const handleChange = (id, index, value) => {
    if (id === "company") {
      setFilters(
        update(filters, {
          [id]: { $set: value },
          sites: {
            $set: map(
              get(
                filter(get(user, ["companies"]), (c) => c.id === value),
                [0, "sites"]
              ),
              (s) => s.id
            ),
          },
        })
      );
    } else {
      setFilters(
        update(filters, {
          [id]: { $set: value },
        })
      );
    }
  };

  return (
    <Box className={classes.gridLine}>
      <Box>
        <FormSection
          formValue={[get(filters, ["company"])]}
          setFormValue={handleChange}
          title2={I18n.get("site_company")}
          id={"company"}
          type="select"
          options={{
            options: map(get(user, ["companies"]), (item) => ({
              id: get(item, ["id"]),
              name: get(item, ["name"]),
            })),
          }}
        />
      </Box>
      <Box>
        <FormSection
          formValue={get(filters, ["sites"]) || []}
          setFormValue={handleChange}
          title={"sites"}
          id={"sites"}
          type="select"
          options={{
            selectAll: true,
            multipleSelect: true,
            clickThrough: true,
            options: map(
              get(
                filter(
                  get(user, ["companies"]),
                  (c) => c.id === get(filters, ["company"])
                ),
                [0, "sites"]
              ),
              (item) => ({
                id: get(item, ["id"]),
                name: get(item, ["name"]),
              })
            ),
          }}
        />
      </Box>
      <Box>
        <FormSection
          formValue={get(filters, ["profileTypes"]) || []}
          setFormValue={handleChange}
          title2={I18n.get("profiles_profileTypes")}
          id={"profileTypes"}
          type="select"
          options={{
            selectAll: true,
            multipleSelect: true,
            clickThrough: true,
            options: map(profileTypes, (item) => ({
              id: item.id,
              name: get(item, [`name_${language}`]),
            })),
          }}
        />
      </Box>
      <Box style={{ display: "flex", alignItems: "flex-end" }}>
        <CustomButton
          variant="contained"
          color="primary"
          onClick={() => search(filters)}
        >
          {I18n.get("dashboard_search")}
        </CustomButton>
      </Box>
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

export default connect(mapStateToProps)(withStyles(styles)(OnsiteCountsForm));
